import React from "react"
import { Flex } from "@chakra-ui/react"
import { DioboxEvent } from "sharedTypes"
import PreviewCard from "./PreviewCard"

type Props = {
  event: DioboxEvent
}

const EventDetails = ({ event: { portalDateTimeLocation } }: Props) => (
  <PreviewCard>
    <Flex
      textAlign="center"
      flexDirection="column"
      dangerouslySetInnerHTML={{ __html: portalDateTimeLocation }}
      fontSize="lg"
      w="full"
      minH={8}
      px={8}
    />
  </PreviewCard>
)

export default EventDetails
